import React from 'react';

interface Props {
  compliant: boolean;
}

const ComplianceStatusPill: React.FC<Props> = ({ compliant }) => (
  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${compliant ? 'bg-limedim text-lime' : 'bg-sev-critical/10 text-sev-critical'}`}>
    {compliant ? 'Signals: Ready' : 'Signals: Gaps Found'}
  </span>
);

export default ComplianceStatusPill;
